import React, { useEffect, useRef, ReactNode } from "react";

interface Props {
  onOutsideClick: () => void;
  children: ReactNode;
}

const OutsideClickHandler = ({ onOutsideClick, children }: Props) => {
  const ref = useRef<HTMLDivElement>(null);
  const onOutsideClickRef = useRef(onOutsideClick);
  onOutsideClickRef.current = onOutsideClick;

  useEffect(() => {
    const handleClick = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        onOutsideClickRef.current();
      }
    };

    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  return <div ref={ref}>{children}</div>;
};

export default OutsideClickHandler;
